import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card } from '@airtel/air-design-system';
import { CalloutWidget } from '../../../callout-widget';
import { TypographyWidget } from '../../../typography-widget';
import { SchedulingSlotList } from '../scheduling-slot-list/SchedulingSlotList';
import { getSchedulingSlotListCardStyles } from './SchedulingSlotListCardStyles';
export var SchedulingSlotListCard = props => {
  var selectedCarousel = props.selectedCarousel,
    title = props.title,
    onSelectSlot = props.onSelectSlot,
    callOutWidgetProps = props.callOutWidgetProps,
    onUserAction = props.onUserAction;
  var schedulingSlotListCardStyles = getSchedulingSlotListCardStyles();
  return _jsxs(Card, Object.assign({
    style: schedulingSlotListCardStyles.slotContainer
  }, {
    children: [_jsx(TypographyWidget, {
      text: title,
      type: "title-single-line-md",
      style: schedulingSlotListCardStyles.slotHeaderContainer
    }), (selectedCarousel === null || selectedCarousel === void 0 ? void 0 : selectedCarousel.isEmptySlotList) ? _jsx(CalloutWidget, Object.assign({}, callOutWidgetProps, {
      onUserAction: onUserAction
    })) : _jsx(SchedulingSlotList, {
      selectedCarousel: selectedCarousel,
      onSelectSlot: onSelectSlot
    })]
  }));
};